import React, { type ReactNode } from 'react';

import { DepActionBannerSuffix, type DepActionBannerSuffixProps } from './DepActionBannerSuffix';

import { ActionBannerWrapper, ChildrenWrapper, Interior, Prefix, PrefixWrapper } from './DepActionBanner.style';

export interface DepActionBannerProps extends DepActionBannerSuffixProps {
    children: ReactNode;
    // Consider an optional `prefix` prop to accept
    // a custom emoji (related to "status" type of the Banner).
    suffix?: boolean;
}

export function DepActionBanner({ children, suffix = true, ...suffixProps }: DepActionBannerProps) {
    const suffixMarkup = suffix && <DepActionBannerSuffix {...suffixProps} />;

    return (
        <ActionBannerWrapper>
            <Interior>
                <PrefixWrapper>
                    <Prefix>🎁</Prefix>
                </PrefixWrapper>

                <ChildrenWrapper>{children}</ChildrenWrapper>
                {suffixMarkup}
            </Interior>
        </ActionBannerWrapper>
    );
}
